import {createEntityAdapter} from '@reduxjs/toolkit';

import {EventFacilityBreakdownItem} from 'api/events/events.types';

/**
 * CRUD adapter for handling Event Facility Breakdown data within the store.
 * Sorted by event start time (ascending).
 */
export const eventFacilityBreakdownAdapter =
    createEntityAdapter<EventFacilityBreakdownItem>({
        selectId: (item) => `${item.facilityId}-${item.eventStarts}`,
        sortComparer: (a, b) => a.eventStarts.localeCompare(b.eventStarts),
    });
